module.exports = __webpack_public_path__ + "96b69439a174c6e3aa2972333b8cf36c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-light-italic.svg
// module id = 1568
// module chunks = 0